// extracted by mini-css-extract-plugin
export default {"ranger":"AllRealisationList_ranger__LNOc-"};